<div class="bg-white bg-opacity-50 p-3 rounded mb-3">
  <div class="d-flex justify-content-between">
    <h6 class="line-2" style="max-width: 70%">
      {{ workshop.title }}
    </h6>
  </div>
  <div class="mt-3">
    <span class="fa fa-user me-2 text-secondary"></span>
    <span class="align-self-center"
      >{{ "trainingHist.labels.teacher" | translate }}:
      {{ workshop.teacherFullName }}</span
    >
  </div>
  <div class="mt-2 d-flex">
    <span class="fa fa-calendar-alt me-2 text-secondary"></span>
    <span class="align-self-center"
      >{{ "trainingHist.labels.eventDate" | translate }}:
      {{ workshop.holdingDateJalali }}
      <span
        class="bg-warning p-1 rounded ms-2 align-self-center"
        style="text-wrap: nowrap"
        *ngIf="workshop.daysLeft > 0"
        >{{ workshop.daysLeft }} روز دیگر</span
      ></span
    >
  </div>
  <div class="mt-2">
    <span class="fa fa-layer-group me-2 text-secondary"></span>
    <span class="align-self-center"
      >{{ "trainingHist.labels.method" | translate }}:
      {{ workshop.holdingTypeTitle }}</span
    >
  </div>
  <div class="mt-2" *ngIf="workshop.locationTitle?.length">
    <span class="fa fa-location-dot me-2 text-secondary"></span>
    <span class="align-self-center"
      >{{ "trainingHist.labels.location" | translate }}:
      {{ workshop.locationTitle }}</span
    >
  </div>
  <a
    class="btn btn-outline-success btn-block mt-3 ms-2"
    target="_blank"
    href="{{ workshop.googleCalendarNewEventUrl }}"
    *ngIf="workshop?.googleCalendarNewEventUrl"
  >
    <span class="fa fa-add me-2"></span>
    {{ "labels.addToCalendar" | translate }}
  </a>
</div>
